import {FunctionComponent, useEffect, useState} from "react";

interface Props {
    env: string;
}

interface User {
    firstname:string;
    lastname:string;
    country:string;
    institution:string;
    email:string;
    laboratoryIsDesignatedNationalReferenceLaboratory:boolean;
}

interface UserWithName {
    name:string;
    username:string;
}

const MembershipAdminApp: FunctionComponent<Props> = ({env}) => {
    const [users,setUsers] = useState<UserWithName[]|null>(null);
    const [user,setUser] = useState<User|null>(null);
    const getUserDetail = async (email:string) => {
        const res = await fetch("GetUserDetail", {
            method:'POST',
            headers:{
                "Content-Type":"application/json"
            },
            body: JSON.stringify({email:email})
        });
        const data= await res.json();
        console.log(data);
        setUser(data);
    };
    
    const approveUser = async (email:string) => {
      const res = await fetch("ApproveUser", {
         method:"POST",
         headers:{
             "Content-Type":"application/json"
         },
         body: JSON.stringify({email:email})
      });
      if (res.ok){
          setUser(null);
          await getData();
      }
    };

    const deleteUser = async (email:string) => {
        const res = await fetch("DenyUser", {
            method:"POST",
            headers:{
                "Content-Type":"application/json"
            },
            body: JSON.stringify({email:email})
        });
        if (res.ok){
            setUser(null);
            await getData();
        }
    };
    const getData = async()=>{
        const res = await fetch("GetUserList", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({}),
        });
        const data = await res.json();
        setUsers(data);
    };
    useEffect(() =>{
        console.log(env);
        getData();
    }, []);    
    return (
        <>
            {
                users && (
                    <>
                    <fieldset>
                        <legend>Nyligen registrerade användare</legend>
                        
                    <dl>
                        {
                            users.map((user,index)=>(
                                <>
                                    <dt key={index}>{user.name}</dt>
                                    <dd onClick={()=>getUserDetail(user.username)}>{user.username}</dd>
                                </>
                                )
                            )
                        }
                    </dl>
                    </fieldset>
                    <i>Klicka på ett användarnamn för att visa information om användaren.</i>
                    </>
                )
            }
            {
                user && (
                    <>
                        <fieldset>
                            <legend>Användarinformation</legend>
                            <dl>
                                <dt>Användarnamn:</dt>
                                <dd>
                                    {user.email}
                                </dd>
                                <dt>Förnamn:</dt>
                                <dd>
                                    {user.firstname}
                                </dd>

                                <dt>Efternamn:</dt>
                                <dd>
                                    {user.lastname}
                                </dd>

                                <dt>E-post:</dt>
                                <dd>
                                    {user.email}
                                </dd>

                                <dt>Myndighet:</dt>
                                <dd>
                                    {user.institution}
                                </dd>

                                <dt>Länd:</dt>
                                <dd>
                                    {user.country}
                                </dd>
                                <dt>laboratoryIsDesignatedNationalReferenceLaboratory:</dt>
                                <dd>
                                    {user.laboratoryIsDesignatedNationalReferenceLaboratory.toString()}
                                </dd>
                            </dl>
                        </fieldset>
                        <fieldset>
                            <legend>Hantera användare</legend>
                            <div >
                                <button onClick={()=>approveUser(user?.email)}>Godkänn användare</button>
                            </div>
                            <hr/>
                            <div >
                                Avböj medlemskap:
                                <button onClick={()=>deleteUser(user?.email)}>Ta bort användare</button>
                            </div>
                        </fieldset>
                    </>
                )
            }

        </>
    )
}

export default MembershipAdminApp;